import { FiSearch, FiDownload, FiMail, FiPhone, FiUser, FiMapPin, FiChevronDown, FiChevronUp, FiXCircle, FiAlertCircle } from "react-icons/fi";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import 'react-toastify/dist/ReactToastify.css';
import { BACKEND_URL, makeRequestAuth } from "../../_config/api";
import axios from "axios";

function PropertyQuery() {
    const [touch, setTouch] = useState([]);
    const [pageNo, setPageNo] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [expandedRows, setExpandedRows] = useState({});

    // --- Modal States ---
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [excelModalOpen, setExcelModalOpen] = useState(false);
    const [rejectionData, setRejectionData] = useState({ id: null, reason: "" });


        // --- 🗓️ FOLLOW-UP SYSTEM STATES ---
    const [followUpFilter, setFollowUpFilter] = useState("all");
    const [followUpModal, setFollowUpModal] = useState({
        open: false,
        leadId: null,
        leadName: "",
        date: new Date().toISOString().split('T')[0],
        time: "16:30",
        mode: "Call",
        reminder: "10",
        note: ""
    });

    // Auto calculate status (Due Today / Overdue / Upcoming)
     // Auto calculate status by extracting date/time from followUpReason or item
    const getFollowUpStatusInfo = (item) => {
        if (!item) return null;

        // 🔴 Qualified / Closed / Approved / Rejected leads ke liye Overdue/Due alert na dikhayein
        if (["qualified", "closed", "approved", "rejected"].includes(item.status)) {
            return null;
        }

        let dateStr = item.followUpDate;
        let timeStr = item.followUpTime;


        // Note text me se Date aur Time auto-extract karein
        if (!dateStr && item.followUpReason) {
            const match = item.followUpReason.match(/Scheduled:\s*(\d{4}-\d{2}-\d{2})\s*(\d{2}:\d{2})/);
            if (match) {
                dateStr = match[1];
                timeStr = match[2];
            }
        }

        // Agar status follow_up hai par date mention nahi hai, toh updatedAt date use karein
        if (!dateStr && item.status === "follow_up") {
            dateStr = new Date(item.updatedAt || item.createdAt || Date.now()).toISOString().split('T')[0];
            timeStr = "18:00";
        }

        if (!dateStr) return null;

        const targetDateTime = new Date(`${dateStr}T${timeStr || "00:00"}`);
        const now = new Date();
        const isToday = targetDateTime.toDateString() === now.toDateString();

        if (targetDateTime < now && !isToday) {
            const diffMin = Math.round((now - targetDateTime) / (1000 * 60));
            return { type: "overdue", label: `OVERDUE (${diffMin > 60 ? Math.round(diffMin/60) + ' hrs' : diffMin + ' min'})`, bg: "bg-red-50 text-red-600 border-red-200" };
        } else if (isToday) {
            return { type: "due_today", label: `DUE TODAY, ${timeStr || ''}`, bg: "bg-amber-50 text-amber-600 border-amber-200" };
        } else {
            return { type: "upcoming", label: `UPCOMING: ${dateStr}, ${timeStr || ''}`, bg: "bg-blue-50 text-blue-600 border-blue-200" };
        }
    };




    const pageSize = 10;
    const maxVisiblePages = 5;

    const [filters, setFilters] = useState({
        keyWord: "",
        status: "",
        fromDate: "",  // 👈 NAYA ADD KIYA
        toDate:"",
        listingCategory: "",
        property: "",
    });

    const toggleRow = (id) => {
        setExpandedRows(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const fetchData = async () => {
        try {
            const resData = { ...filters, sortOrder: "desc", sortBy: "createdAt", pageNo, size: pageSize, handlePropertyBy: 'PropertyLeTeam' };
            const response = await makeRequestAuth("post", "/admin/getPropertyContantList", resData);
            setTouch(response?.data?.list || []);
            setTotalCount(response?.data?.total || 0);
        } catch (err) {
            showErrorToast("Failed to fetch data");
        }
    };

    useEffect(() => { fetchData(); }, [pageNo, filters]);

    // Main Status Handler
    // Main Status Handler
    const handleStatusUpdate = async (id, newStatus, item) => {
        // 🔴 Status REJECTED -> Rejection Modal Khulega
        if (newStatus === "rejected") {
            setRejectionData({ id: id, status: newStatus, reason: "" });
            setIsModalOpen(true);
            return;
        }

        // 🟠 Status FOLLOW UP -> Schedule Follow-up Modal (Image 2) Khulega
        if (newStatus === "follow_up") {
            const currentItem = item || touch.find(t => t._id === id);
            setFollowUpModal({
                open: true,
                leadId: id,
                leadName: currentItem?.name || "User",
                date: currentItem?.followUpDate || new Date().toISOString().split('T')[0],
                time: currentItem?.followUpTime || "16:30",
                mode: currentItem?.followUpMode || "Call",
                reminder: "10",
                note: currentItem?.followUpReason || ""
            });
            return;
        }

        try {
            await makeRequestAuth("post", "/admin/updateContactStatus", {
                touchId: id,
                status: newStatus
            });
            showSuccessToast(`Status updated to ${newStatus}`);
            fetchData();
        } catch (err) {
            showErrorToast("Update failed");
        }
    };


    // Submit Rejection from Modal
   const submitRejection = async () => {
    if (!rejectionData.reason.trim()) {
        return showErrorToast("Please enter a note / reason");
    }

    try {
        await makeRequestAuth("post", "/admin/updateContactStatus", {
            touchId: rejectionData.id,
            status: rejectionData.status,
            reason: rejectionData.reason
        });
        showSuccessToast("Status Updated Successfully");
        setIsModalOpen(false);
        fetchData();
    } catch (err) {
        showErrorToast("Update failed");
    }
};


    const handleExcelDownload = async () => {
        setExcelModalOpen(false);
        const { token } = JSON.parse(sessionStorage.getItem("user")) || {};
        if (!token || touch.length === 0) return showErrorToast("No data to download");
        try {
            const res = await axios.post(BACKEND_URL + "/admin/exportPropertyQueryExcel", { ...filters }, {
                responseType: "blob",
                headers: { Authorization: `Bearer ${token}` },
            });
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const a = document.createElement("a");
            a.href = url;
            a.download = `queries_${Date.now()}.xlsx`;
            document.body.appendChild(a); a.click(); a.remove();
        } catch (err) { showErrorToast("Excel download failed"); }
    };

    const getPageNumbers = () => {
        const totalPages = Math.ceil(totalCount / pageSize);
        const start = Math.max(1, pageNo - Math.floor(maxVisiblePages / 2));
        const end = Math.min(start + maxVisiblePages - 1, totalPages);
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    };

    const totalPages = Math.ceil(totalCount / pageSize);

    return (
        <div className="p-6 bg-slate-50 min-h-screen relative font-sans">
            <ToastContainer position="top-right" />

            {/* --- CUSTOM REJECTION MODAL --- */}
           {/* --- CUSTOM DYNAMIC STATUS MODAL --- */}
{isModalOpen && (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        {/* Backdrop */}
        <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={() => setIsModalOpen(false)}></div>

        {/* Modal Content */}
        <div className="relative bg-white w-full max-w-md rounded-[2.5rem] shadow-2xl p-8 animate-in fade-in zoom-in duration-200">
            <div className="flex flex-col items-center text-center">
                {/* Dynamic Icon Theme */}
                <div className={`w-16 h-16 rounded-3xl flex items-center justify-center mb-4 ${
                    rejectionData.status === 'follow_up' ? 'bg-amber-100 text-amber-600' : 'bg-red-100 text-red-600'
                }`}>
                    <FiAlertCircle size={32} />
                </div>
                
                {/* Dynamic Title */}
                <h3 className="text-xl font-black text-slate-800">
                    {rejectionData.status === 'follow_up' ? 'Follow Up Query?' : 'Reject Query?'}
                </h3>
                
                {/* Dynamic Subtitle */}
                <p className="text-slate-500 text-sm mt-1">
                    {rejectionData.status === 'follow_up' 
                        ? 'Please provide a note/remark for follow up. This will be saved for reference.' 
                        : 'Please provide a reason for rejecting this lead. This will be saved for future reference.'}
                </p>
            </div>

            {/* Dynamic Textarea Placeholder */}
            <textarea
                className={`w-full mt-6 p-4 bg-slate-50 border-2 border-slate-100 rounded-2xl outline-none text-sm font-medium transition-all ${
                    rejectionData.status === 'follow_up' ? 'focus:border-amber-500' : 'focus:border-red-500'
                }`}
                rows="4"
                placeholder={rejectionData.status === 'follow_up' ? 'Type follow up note here...' : 'Type rejection reason here...'}
                value={rejectionData.reason}
                onChange={(e) => setRejectionData({ ...rejectionData, reason: e.target.value })}
            ></textarea>

            <div className="grid grid-cols-2 gap-3 mt-6">
                <button
                    onClick={() => setIsModalOpen(false)}
                    className="py-3 px-4 rounded-2xl font-bold text-slate-500 hover:bg-slate-100 transition-all"
                >
                    Cancel
                </button>
                
                {/* Dynamic Button Color & Text */}
                <button
                    onClick={submitRejection}
                    className={`py-3 px-4 rounded-2xl text-white font-bold transition-all shadow-lg ${
                        rejectionData.status === 'follow_up' 
                            ? 'bg-amber-500 hover:bg-amber-600 shadow-amber-100' 
                            : 'bg-red-600 hover:bg-red-700 shadow-red-100'
                    }`}
                >
                    {rejectionData.status === 'follow_up' ? 'Confirm Follow Up' : 'Confirm Rejection'}
                </button>
            </div>
        </div>
    </div>
)}


            {/* 🗓️ SCHEDULE FOLLOW-UP POPUP MODAL */}
            {followUpModal.open && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={() => setFollowUpModal({ ...followUpModal, open: false })}></div>

                    <div className="relative bg-white w-full max-w-lg rounded-[2.5rem] shadow-2xl p-8 animate-in fade-in zoom-in duration-200">
                        <h3 className="text-xl font-black text-slate-800 mb-1">
                            Schedule Follow-up — <span className="text-[#24ADD7]">{followUpModal.leadName}</span>
                        </h3>
                        <p className="text-slate-400 text-xs font-medium mb-6">Set date, time, reminder and remarks for next call.</p>

                        <div className="space-y-4">
                            <div className="grid grid-cols-2 gap-3">
                                <div>
                                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-1">Follow-up Date</label>
                                    <input 
                                        type="date" 
                                        value={followUpModal.date}
                                        onChange={(e) => setFollowUpModal({ ...followUpModal, date: e.target.value })}
                                        className="w-full p-3 bg-slate-50 border border-slate-200 rounded-2xl outline-none text-xs font-bold"
                                    />
                                </div>
                                <div>
                                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-1">Follow-up Time</label>
                                    <input 
                                        type="time" 
                                        value={followUpModal.time}
                                        onChange={(e) => setFollowUpModal({ ...followUpModal, time: e.target.value })}
                                        className="w-full p-3 bg-slate-50 border border-slate-200 rounded-2xl outline-none text-xs font-bold"
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-3">
                                <div>
                                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-1">Mode</label>
                                    <select
                                        value={followUpModal.mode}
                                        onChange={(e) => setFollowUpModal({ ...followUpModal, mode: e.target.value })}
                                        className="w-full p-3 bg-slate-50 border border-slate-200 rounded-2xl outline-none text-xs font-bold"
                                    >
                                        <option value="Call">📞 Call</option>
                                        <option value="WhatsApp">💬 WhatsApp</option>
                                        <option value="Site Visit">🏠 Site Visit</option>
                                    </select>
                                </div>
                                <div>
                                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-1">Reminder</label>
                                    <select
                                        value={followUpModal.reminder}
                                        onChange={(e) => setFollowUpModal({ ...followUpModal, reminder: e.target.value })}
                                        className="w-full p-3 bg-slate-50 border border-slate-200 rounded-2xl outline-none text-xs font-bold"
                                    >
                                        <option value="0">At time of call</option>
                                        <option value="10">10 min before</option>
                                        <option value="30">30 min before</option>
                                        <option value="60">1 hour before</option>
                                    </select>
                                </div>
                            </div>

                            <div>
                                <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-1">Follow-up Note / Remarks</label>
                                <textarea
                                    rows="3"
                                    placeholder="Client requested call regarding budget / site visit..."
                                    value={followUpModal.note}
                                    onChange={(e) => setFollowUpModal({ ...followUpModal, note: e.target.value })}
                                    className="w-full p-3 bg-slate-50 border border-slate-200 rounded-2xl outline-none text-xs font-medium"
                                ></textarea>
                            </div>
                        </div>

                        <div className="grid grid-cols-2 gap-3 mt-6">
                            <button
                                onClick={() => setFollowUpModal({ ...followUpModal, open: false })}
                                className="py-3 px-4 rounded-2xl font-bold text-slate-500 hover:bg-slate-100 transition-all text-xs"
                            >
                                Cancel
                            </button>
                                                       <button
                                onClick={async () => {
                                    if (!followUpModal.note.trim()) return showErrorToast("Please enter a follow-up note");
                                    try {
                                        // Date, Time aur Mode ko note me merge karke bheja
                                        const formattedReason = `${followUpModal.note} (Scheduled: ${followUpModal.date} ${followUpModal.time} via ${followUpModal.mode})`;

                                        await makeRequestAuth("post", "/admin/updateContactStatus", {
                                            touchId: followUpModal.leadId,
                                            status: "follow_up",
                                            reason: formattedReason
                                        });
                                        showSuccessToast("Follow-up Scheduled Successfully! 🔔");
                                        setFollowUpModal({ ...followUpModal, open: false });
                                        fetchData();
                                    } catch (err) {
                                        showErrorToast("Failed to schedule follow-up");
                                    }
                                }}
                                className="py-3 px-4 rounded-2xl bg-amber-500 hover:bg-amber-600 text-white font-bold transition-all shadow-lg shadow-amber-200 text-xs"
                            >
                                💾 Save Follow-up
                            </button>

                        </div>
                    </div>
                </div>
            )}



            <div className="max-w-7xl mx-auto space-y-6">
                {/* Header */}
                <div className="bg-white p-6 rounded-3xl shadow-sm border border-slate-200 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                    <div>
                        <h2 className="text-3xl font-black text-slate-800 tracking-tight">Lead Center</h2>
                        <p className="text-slate-500 text-sm font-medium italic">Property Query Management Dashboard</p>
                    </div>
                    {/* DATE FILTERS AND EXPORT BUTTON */}
<div className="flex flex-wrap items-center gap-4">
    <button onClick={() => setExcelModalOpen(true)} className="flex items-center gap-2 bg-slate-900 hover:bg-black text-white px-6 py-3 rounded-2xl font-bold text-sm transition-all shadow-xl shadow-slate-200">
        <FiDownload /> Export Data
    </button>
</div>

                </div> 


                                {/* 📊 1. TOP SUMMARY CARDS */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div 
                        onClick={() => setFollowUpFilter("all")}
                        className={`p-5 rounded-3xl border transition-all cursor-pointer shadow-sm ${followUpFilter === 'all' ? 'bg-blue-600 text-white border-blue-600 shadow-blue-200' : 'bg-white text-slate-800 border-slate-100 hover:border-blue-200'}`}
                    >
                        <p className={`text-xs font-bold uppercase tracking-wider ${followUpFilter === 'all' ? 'text-blue-100' : 'text-slate-400'}`}>Total Leads</p>
                        <h3 className="text-2xl md:text-3xl font-black mt-2">{totalCount}</h3>
                    </div>

                    <div 
                        onClick={() => setFollowUpFilter("due_today")}
                        className={`p-5 rounded-3xl border transition-all cursor-pointer shadow-sm ${followUpFilter === 'due_today' ? 'bg-amber-500 text-white border-amber-500 shadow-amber-200' : 'bg-white text-slate-800 border-slate-100 hover:border-amber-200'}`}
                    >
                        <p className={`text-xs font-bold uppercase tracking-wider ${followUpFilter === 'due_today' ? 'text-amber-100' : 'text-slate-400'}`}>Due Today</p>
                        <h3 className="text-2xl md:text-3xl font-black mt-2">
                            {touch.filter(i => getFollowUpStatusInfo(i)?.type === 'due_today').length}
                        </h3>
                    </div>

                    <div 
                        onClick={() => setFollowUpFilter("overdue")}
                        className={`p-5 rounded-3xl border transition-all cursor-pointer shadow-sm ${followUpFilter === 'overdue' ? 'bg-red-600 text-white border-red-600 shadow-red-200' : 'bg-white text-slate-800 border-slate-100 hover:border-red-200'}`}
                    >
                        <p className={`text-xs font-bold uppercase tracking-wider ${followUpFilter === 'overdue' ? 'text-red-100' : 'text-slate-400'}`}>Overdue</p>
                        <h3 className="text-2xl md:text-3xl font-black mt-2">
                            {touch.filter(i => getFollowUpStatusInfo(i)?.type === 'overdue').length}
                        </h3>
                    </div>

                    <div 
                        onClick={() => setFollowUpFilter("completed")}
                        className={`p-5 rounded-3xl border transition-all cursor-pointer shadow-sm ${followUpFilter === 'completed' ? 'bg-emerald-600 text-white border-emerald-600 shadow-emerald-200' : 'bg-white text-slate-800 border-slate-100 hover:border-emerald-200'}`}
                    >
                        <p className={`text-xs font-bold uppercase tracking-wider ${followUpFilter === 'completed' ? 'text-emerald-100' : 'text-slate-400'}`}>Qualified / Closed</p>
                        <h3 className="text-2xl md:text-3xl font-black mt-2">
                            {touch.filter(i => i.status === 'approved').length}
                        </h3>
                    </div>
                </div>


                {/* Filters */}
                <div className="bg-white p-4 rounded-[2rem] shadow-sm border border-slate-100 grid grid-cols-1 sm:grid-cols-4 gap-3">
                    {/* Search Input - Large */}
                    <div className="relative sm:col-span-3">
                        <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
                        <input
                            type="text"
                            placeholder="Search..."
                            className="w-full pl-11 pr-4 py-3 bg-slate-50 border-none rounded-2xl focus:ring-2 focus:ring-blue-500/20 outline-none text-sm font-bold"
                            value={filters.keyWord}
                            onChange={(e) => {
                                setFilters(f => ({ ...f, keyWord: e.target.value }));
                                setPageNo(1);
                            }}
                        />
                    </div>

                    {/* Status Select - Small */}
                    <div className="relative sm:col-span-1">
                        <select
                            value={filters.status}
                            onChange={(e) => {
                                setFilters(f => ({
                                    ...f,
                                    status: e.target.value
                                }));
                                setPageNo(1);
                            }}
                            className="w-full px-4 py-3 bg-slate-50 border-none rounded-2xl focus:ring-2 focus:ring-blue-500/20 outline-none text-sm font-bold text-slate-600"
                        >
                            <option value="">All Status</option>
                            <option value="pending">🟡 In Progress</option>
                            <option value="approved">🟢 Qualified</option>
                            <option value="rejected">🔴 Rejected</option>
                        </select>
                    </div>
                </div>

                {/* Query Cards */}
                  {/* Query Cards */}
                <div className="grid gap-4">
                    {touch
                        .filter((item) => {
                            if (followUpFilter === "all") return true;
                            if (followUpFilter === "due_today") return getFollowUpStatusInfo(item)?.type === "due_today";
                            if (followUpFilter === "overdue") return getFollowUpStatusInfo(item)?.type === "overdue";
                            if (followUpFilter === "completed") return item.status === "approved";
                            return true;
                        })
                        .map((item) => (
                        <div key={item._id} className="group bg-white border border-slate-200 rounded-[2.5rem] overflow-hidden transition-all hover:border-blue-300">

                            <div className="p-6 flex flex-col lg:flex-row justify-between gap-6">
                                <div className="flex-grow grid grid-cols-1 md:grid-cols-3 gap-6">
                                    <div className="flex items-center gap-4">
                                        <div className="w-14 h-14 bg-gradient-to-br from-[#41C9F0] to-[#0C6B85] text-white rounded-[1.25rem] flex items-center justify-center font-black text-xl shadow-lg shadow-blue-200">
                                            {item.name?.charAt(0) || "U"}
                                        </div>
                                        <div>
                                            <h4 className="font-black text-slate-800 text-lg leading-tight">{item.name || "Unknown User"}</h4>
                                            <div className="flex items-center gap-2 mt-1">
                                                <span className={`h-2 w-2 rounded-full ${item.status === 'approved' ? 'bg-emerald-500' : item.status === 'rejected' ? 'bg-red-500' : 'bg-amber-500'}`}></span>
                                                <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">{item.status || "Pending"}</span>
                                            </div>
                                        </div>

                                                                                    {/* ⏰ Next Follow-up Badge */}
                                          {/* ⏰ Next Follow-up Badge */}
{(() => {
    const info = getFollowUpStatusInfo(item);
    return info ? (
        <div className={`mt-2 px-3 py-1 rounded-xl text-xs font-bold border inline-flex items-center gap-1.5 ${info.bg}`}>
            <span>📅</span> {info.label}
        </div>
    ) : null;
})()}


                                    </div>

                                    <div className="flex flex-col justify-center space-y-1.5">
                                        <div className="flex items-center gap-3 text-sm font-bold text-slate-600">
                                            <div className="p-1.5 bg-slate-100 rounded-lg"><FiMail size={14} /></div> {item.email || "---"}
                                        </div>
                                        <div className="flex items-center gap-3 text-sm font-bold text-slate-600">
                                            <div className="p-1.5 bg-slate-100 rounded-lg"><FiPhone size={14} /></div> {item.phone || "---"}
                                        </div>
                                    </div>

                                    <div className="flex items-center">
                                        <select
                                            value={item.status || "pending"}
                                            onChange={(e) => handleStatusUpdate(item._id, e.target.value, item)}
                                            className={`text-xs font-black uppercase px-4 py-2.5 rounded-2xl border-2 outline-none w-full md:w-fit cursor-pointer transition-all ${item.status === 'rejected' ? 'bg-red-50 border-red-100 text-red-600' :
                                                item.status === 'approved' ? 'bg-emerald-50 border-emerald-100 text-emerald-600' :
                                                    'bg-amber-50 border-amber-100 text-amber-600'
                                                }`}
                                        >
                                            <option value="pending">🟡 In Progress</option>
                                            <option value="follow_up">🟠 Follow Up</option>
                                            <option value="approved">🟢 Qualified</option>
                                            <option value="rejected">🔴 Rejected</option>
                                        </select>
                                    </div>
                                    
                                    <button
                                            onClick={() => setFollowUpModal({
                                                open: true,
                                                leadId: item._id,
                                                leadName: item.name || "User",
                                                date: item.followUpDate || new Date().toISOString().split('T')[0],
                                                time: item.followUpTime || "16:30",
                                                mode: item.followUpMode || "Call",
                                                reminder: "10",
                                                note: item.followUpReason || ""
                                            })}
                                            className="px-3.5 py-2.5 bg-amber-500 text-white rounded-2xl text-xs font-bold hover:bg-amber-600 transition shadow-sm ml-2"
                                        >
                                            📅 Schedule
                                        </button>

                                </div>

                                <div className="flex items-center justify-end">
                                    <button
                                        onClick={() => toggleRow(item._id)}
                                        className="p-3 bg-slate-50 hover:bg-blue-100 hover:text-[#24ADD7] rounded-2xl text-slate-400 transition-all"
                                    >
                                        {expandedRows[item._id] ? <FiChevronUp size={24} /> : <FiChevronDown size={24} />}
                                    </button>
                                </div>
                            </div>

                            {/* Expanded Details */}
                            {expandedRows[item._id] && (
                                <div className="p-8 bg-slate-50/50 border-t border-slate-100 space-y-6">
                                    {item.status === 'rejected' && (
                                        <div className="bg-white border-l-4 border-red-500 p-5 rounded-2xl shadow-sm flex gap-4">
                                            <FiXCircle className="text-red-500 shrink-0 mt-1" size={20} />
                                            <div>
                                                <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">Internal Note: Rejection Reason</p>
                                                <p className="text-sm font-bold text-slate-700 leading-relaxed">{item.rejectedReason || "No reason provided."}</p>
                                            </div>
                                        </div>
                                    )}

                                    {item.property ? (
                                        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                                            <div className="md:col-span-1">
                                                <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Requirement</p>
                                                <div className="bg-white p-4 rounded-3xl border border-slate-100 shadow-sm">
                                                    <p className="text-lg font-black text-slate-800 uppercase tracking-tighter">{item.property.listingCategory}</p>
                                                    <p className="text-xs font-bold text-[#24ADD7]">{item.property.propertyType}</p>
                                                    <p className="mt-3 text-xl font-black text-slate-900">₹{item.property.price}</p>
                                                </div>
                                            </div>
                                            {item.followUpReason && (
    <div className="mt-3 bg-amber-50 p-3 rounded-xl border border-amber-200">
        <p className="text-[10px] font-black text-amber-600 uppercase tracking-widest">Follow-Up Note:</p>
        <p className="text-xs font-bold text-amber-900 mt-1">"{item.followUpReason}"</p>
    </div>
)}

                                            <div className="md:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-6">
                                                <div>
                                                    <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Location & Address</p>
                                                    <p className="text-sm font-bold text-slate-700 flex items-center gap-2"><FiMapPin className="text-[#24ADD7]" /> {item.property.city}, {item.property.location}</p>
                                                    <p className="text-xs text-slate-500 mt-2 leading-relaxed font-medium italic">"{item.property.propertyAddress}"</p>
                                                </div>
                                                <div>
                                                    <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Property Assets</p>
                                                    <div className="flex flex-wrap gap-2">
                                                        {item.property.uploadedPhotos?.map((img, i) => (
                                                            <img key={i} src={img} className="w-16 h-16 rounded-2xl object-cover border-4 border-white shadow-sm" alt="property" />
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="text-center py-6 text-slate-400 font-medium">No linked property data available.</div>
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                {/* Pagination UI... (kept same as before) */}
{excelModalOpen && (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
        <div className="bg-white rounded-2xl w-full max-w-md overflow-hidden shadow-2xl p-6">
            <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-extrabold text-slate-800">Export Data</h3>
                <button
                    onClick={() => setExcelModalOpen(false)}
                    className="text-gray-400 hover:text-red-500 transition-colors"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                </button>
            </div>
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-1">Start Date</label>
                    <input
                        type="date"
                        value={filters.fromDate}
                        onChange={(e) =>
                            setFilters({ ...filters, fromDate: e.target.value })
                        }
                        className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm text-[#434646] focus:border-[#24ADD7] outline-none"
                    />
                </div>
                <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-1">End Date</label>
                    <input
                        type="date"
                        value={filters.toDate}
                        onChange={(e) =>
                            setFilters({ ...filters, toDate: e.target.value })
                        }
                        className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm text-[#434646] focus:border-[#24ADD7] outline-none"
                    />
                </div>
            </div>
            <div className="flex justify-end gap-3 mt-8">
                <button
                    onClick={() => setExcelModalOpen(false)}
                    className="px-5 py-2.5 border border-gray-200 rounded-xl text-sm font-bold text-gray-600 hover:bg-gray-50 transition-all"
                >
                    Cancel
                </button>
                <button
                    onClick={handleExcelDownload}
                    className="flex items-center gap-2 px-6 py-2.5 bg-[#24ADD7] text-white rounded-xl text-sm font-black hover:bg-[#198cae] transition-all shadow-lg shadow-cyan-100"
                >
                    Export
                </button>
            </div>
        </div>
    </div>
)}

            </div>
        </div>
    );
}

export default PropertyQuery;